export default __webpack_public_path__ + "static/media/icon-map-pin-add-filled.e8d733d7.svg";